<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OJ0BaE/tc-custom/9781847674920.jpg?1734492075816" alt="This image is the cover for the book Question of Loyalties, Canongate Classics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Question of Loyalties, Canongate Classics
      </h1>
      <p class="bookDescription body article font2">
        <b>A man returns to France to unravel the truth about his father’s actions during WWII in “a novel of scope, substance and strength all too rare today” (<i>Spectator</i>).</b><br/>  <br/> Widely acclaimed as Allan Massie’s finest novel, <i>A Question of Loyalties</i> explores the complexities of loyalty, nationality, and family legacy after the horrors of World War II. Rife with the anguish of hindsight and the irony of circumstance, this powerful book is “addictively narrated . . . Out of one broken man’s story evolves the weighty history and treachery of a whole era” (<i>The Times</i>).<br/>  <br/> Etienne de Balafré, half French, half English, and raised in South Africa, returns to postwar France to unravel the tangled history of his father. Was Lucien de Balafré a patriot who served his country as best he could in difficult times, or a treacherous collaborator in the Vichy government?<br/>  <br/><b>“I have no hesitation in calling it a major novel . . . Massie here has vigorously pushed back the narrowing boundaries of English fiction.” —<i>Spectator</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Allan Massie, Alan Taylor
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canongate
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?58ef2f26